import { TranslateRequiredTableColumns } from "@ui-components/AgGridTable/constants";
import { RequiredTableCols } from "@ui-components/AgGridTable/constants/tableCols";

const DmsSpecificCols = {
    IS_ACCOUNTING_ATTACHED: "isAttached",
    IS_TRANSACTION_ATTACHED: "isTransactionAttached",
    IS_CASH_REGISTER_ATTACHED: "isCashRegisterAttached",
    DOCUMENT_DATE: "documentDate",
    CONTACT: "contactId",
    CONTACT_CLASSIFICATION: "contactClassification",
    DOCUMENT_NUMBER: "documentNumber",
    INTERNE_NUMBER: "interneNumber",
    TAG: "tag",
    DOCUMENT_AMOUNT: "documentAmount",
    DOCUMENT_AMOUNT_TYPE: "documentAmountType",
    DOCUMENT_ORIGINAL_AMOUNT: "originalAmount",
    CURRENCY: "currency",
    DESCRIPTION: "description",
    FILE_NAME: "fileName",
    NUM_PAGES: "numPages",
    CREATED_AT: "createdAt",
    CREATED_BY: "createdBy",
    VAT_NB: "vatNumber",
    CURRENCY_RATE: "currencyRate",
    DEADLINE_DAYS: "deadlineDays",
    DISCOUNT_AMOUNT: "discountAmount",
    DISCOUNT_DATE: "discountDate",
    DISCOUNT_DAYS: "discountDays",
    DISCOUNT_PERCENT: "discountPercent",
    DUE_DATE: "dueDate",
    NOTES: "notes",
    PAYMENT_TYPE: "paymentType",
    TYPE: "type",
    SUB_TYPE: "subType",
    HAS_XRECHNUNG: "hasXRechnung",
    HAS_MARKDOWN: "hasMarkdown",
    BEWIRTUNG: "bewirtung",
    UPDATED_AT: "updatedAt",
    REVIEW: "review",
    PAYMENT_STATUS: "paymentStatus",
    LOGS: "logs",
} as const;

export const DmsTableCols = { ...RequiredTableCols, ...DmsSpecificCols } as const;

export const TranslateDmsTableColumns = {
    ...TranslateRequiredTableColumns,
    [DmsTableCols.NUM_PAGES]: "app.fields.numPages",
    [DmsTableCols.IS_ACCOUNTING_ATTACHED]: "app.dms.isAttached",
    [DmsTableCols.IS_TRANSACTION_ATTACHED]: "app.dms.isTransactionAttached",
    [DmsTableCols.IS_CASH_REGISTER_ATTACHED]: "app.dms.isCashRegisterAttached",
    [DmsTableCols.CREATED_AT]: "app.dms.createdAt",
    [DmsTableCols.CREATED_BY]: "app.dms.userName",
    [DmsTableCols.VAT_NB]: "app.fields.vatNb",
    [DmsTableCols.CURRENCY]: "app.fields.currency",
    [DmsTableCols.CURRENCY_RATE]: "app.fields.currency.rate",
    [DmsTableCols.DEADLINE_DAYS]: "app.fields.deadlineDays",
    [DmsTableCols.DESCRIPTION]: "app.fields.description",
    [DmsTableCols.DISCOUNT_AMOUNT]: "app.fields.discountAmount",
    [DmsTableCols.DISCOUNT_DATE]: "app.fields.discountDate",
    [DmsTableCols.DISCOUNT_DAYS]: "app.fields.discountDays",
    [DmsTableCols.DISCOUNT_PERCENT]: "app.fields.discountPercent",
    [DmsTableCols.DOCUMENT_AMOUNT]: "app.fields.betrag",
    [DmsTableCols.DOCUMENT_ORIGINAL_AMOUNT]: "app.fields.originalAmount",
    [DmsTableCols.DOCUMENT_AMOUNT_TYPE]: "app.fields.betragType",
    [DmsTableCols.DOCUMENT_DATE]: "app.fields.date",
    [DmsTableCols.DOCUMENT_NUMBER]: "app.dms.documentNumber",
    [DmsTableCols.DUE_DATE]: "app.fields.dueDate",
    [DmsTableCols.FILE_NAME]: "app.fields.bezeichnung",
    [DmsTableCols.INTERNE_NUMBER]: "app.fields.internal_num",
    [DmsTableCols.NOTES]: "app.fields.notes",
    [DmsTableCols.CONTACT]: "app.fields.contact",
    [DmsTableCols.CONTACT_CLASSIFICATION]: "app.titles.contacts.classification",
    [DmsTableCols.PAYMENT_TYPE]: "app.fields.paymentMethod",
    [DmsTableCols.TYPE]: "app.dms.typeOfDocuments",
    [DmsTableCols.SUB_TYPE]: "app.fields.subType",
    [DmsTableCols.UPDATED_AT]: "app.dms.updatedAt",
    [DmsTableCols.HAS_XRECHNUNG]: "app.dms.hasXRechnung",
    [DmsTableCols.HAS_MARKDOWN]: "app.dms.hasMarkdown",
    [DmsTableCols.BEWIRTUNG]: "app.dms.bewirtung.column",
    [DmsTableCols.TAG]: "app.titles.tag",
    [DmsTableCols.REVIEW]: "app.fields.freigabe",
    [DmsTableCols.PAYMENT_STATUS]: "app.fields.payment",
    [DmsTableCols.LOGS]: "app.dms.logs",
};

export const ExcludedColsFromSetting = [
    DmsTableCols.DRAG,
    DmsTableCols.ROW_NUMBER,
    DmsTableCols.ACTIONS,
    DmsTableCols.NOTES,
    DmsTableCols.IS_ACCOUNTING_ATTACHED,
    // DmsTableCols.IS_TRANSACTION_ATTACHED,
    // DmsTableCols.IS_CASH_REGISTER_ATTACHED,
    DmsTableCols.CONTACT,
] as const;
